import axios from 'axios';
import {url} from '../../../utils/urls';

const withCredentials = true;

export const getTrendingNowConfiguration = ({siteUUID}) =>
  axios.get(`${url.tnu.pubPortal.sites}/trending-now-units/configuration/${siteUUID}`, {withCredentials});

export const getTrendingNowCodeForSite = siteUUID =>
  axios.get(`${url.tnu.pubPortal.sites}/trending-now-units/code/${siteUUID}`, {withCredentials});

export const getTestPage = ({trendingNowUnitUUID}) =>
  `${url.tnu.trendingNowUnits}/${trendingNowUnitUUID}/test-page`;

export const setTrendingNowConfiguration = ({
  configurationUUIDTrending,
  siteUUID,
  titleTrending,
  display,
  placeholder_img_url,
  placeholder_img_file,
  visible_amount,
  selected_timeframe,
  selection_method,
  commenting_enabled,
  sentiment_enabled,
}) => {
  const formData = new FormData()

  formData.append('uuid', configurationUUIDTrending)
  formData.append('title', titleTrending)
  formData.append('display', display)
  if (placeholder_img_url) formData.append('placeholder_img_url', placeholder_img_url)
  if (placeholder_img_file) formData.append('placeholder_img_file', placeholder_img_file)
  formData.append('visible_amount', visible_amount)
  formData.append('selected_timeframe', selected_timeframe)
  formData.append('selection_method', selection_method)
  formData.append('commenting_enabled', commenting_enabled)
  formData.append('sentiment_enabled', sentiment_enabled)

  return axios.put(`${url.tnu.pubPortal.trendingNowUnits}/configuration/${siteUUID}`,
    formData,
    {withCredentials}
  )}
